import { render, staticRenderFns } from "./TemplateCapa.vue?vue&type=template&id=99b7c920&scoped=true&"
import script from "./TemplateCapa.vue?vue&type=script&lang=js&"
export * from "./TemplateCapa.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCapa.vue?vue&type=style&index=0&id=99b7c920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b7c920",
  null
  
)

export default component.exports